export const PAGE_PATH = '/additional';
